import language from "./language.js";
import images from "./images.js";
import aplikacija from "./aplikcacija.js";
import Settings from "../src/Settings.js";
import app_math from "../src/lib/math";

// #################
// najvaznija opcija je trigger koja definise okidac koji menja promenjljivu
// #################
// specijalni property u objektu su data, data_select, i images
// triger za njih moze residence, country ili city
// ako postoji trigger moraju postojati i adekvatne opcije default
// data, data_select, i images property se menja kada evnironment varijabla na koju njegov trigger ukazuje promeni vrednost
// #################
// drugi specijalni propery u objektu su title i select
// njihov triger se ne navodi jer je podrazumevano language
// i ovde mora postojati default opcija (iako ne postoji trigger)
// title i select property se menja kada language promeni vrednost
// #################
// najvazniji property u objektu je value jer njega moze da podesi korisnik
// ako ima odrednicu source = "computed" onda ima i svoju default vrednost
// default vrednost se podesava na dva nacina
//       kao data_value (sto znaci da se iz data propertija vuce podataka)
//       kao watch (sto znaci da mora da postoji funkcija koja obracunava default podatak)
// #################

export default {
  loc_zone: {
    value: -1,
    data: -1,
    data_default: -1,
    data_trigger: "loc_city_value",
    data_value: "copy",
    source: "computed",
    title: "",
    title_default: "Country zone",
  },
  loc_hd: {
    value: -1,
    data: -1,
    data_default: -1,
    data_trigger: "loc_city_value",
    data_value: "copy",
    source: "computed",
    title: "",
    title_default: "HD (Heating Days)",
  },
  loc_ta: {
    value: -1,
    data: -1,
    data_default: -1,
    data_trigger: "loc_city_value",
    data_value: "copy",
    source: "computed",
    title: "",
    title_default: "TA (Temperature Average)",
  },
  loc_hdd_ref: {
    value: -1,
    data: -1,
    data_default: -1,
    data_trigger: "loc_city_value",
    data_value: "copy",
    source: "computed",
    title: "",
    title_default: "HDD (reference value)",
  },
  loc_ti_ref: {
    value: 0,
    data: 0,
    data_default: 20,
    data_trigger: "loc_country_value",
    data_value: "copy",
    source: "computed",
    title: "",
    title_default: "TI (reference value)",
  },
  loc_hdd: {
    title: "",
    title_default: "HDD (calculated value)",
  },
  loc_internal: {
    value_default: 20,
    value: 20,
    title: "",
    title_default: "Temperature internal",
  },
  // todo - izbaciti ovo
  loc_reference: {
    value: 12,
    title: "",
    title_default: "Temperature reference",
  },
  typ_pozicija: {
    select: [],
    select_default: ["Free standing", "In a row"],
    select_operation: "blend",
    value: 1,
    images: [],
    images_default: [require("../src/assets/images/list_logo.png"), require("../src/assets/images/list_logo.png")],
    images_operation: "blend",
    images_trigger: "loc_country_value",
  },
  app_sklopovi_a: {
    data: aplikacija.sklopovi_grupe,
    images: images.sklopovi_a,
    title: {},
    title_default: language.default.app_sklopovi_a_title,
    title_operation: "blend",
    select: {},
    select_default: language.default.app_sklopovi_a_select,
    select_operation: "blend",
  },
  app_sklopovi_b: {
    images: images.sklopovi_b,
    select: {},
    select_default: language.default.app_sklopovi_b_select,
    select_operation: "blend",
  },
  app_sklopovi_c: {
    images: images.sklopovi_c,
    select: {},
    select_default: language.default.app_sklopovi_c_select,
    select_operation: "blend",
  },
  app_country_pozicije: {
    data: [],
    data_default: [1, 5, 7, 18, 19, 20, 21, 30, 10, 13, 60],
    data_trigger: "loc_country_value",
  },
  app_sklopovi: {
    data: aplikacija.sklopovi,
  },
  app_materijali: {
    data: aplikacija.materijali,
    title: {},
    title_default: language.default.app_materijali_title,
    title_operation: "blend",
    select: {},
    select_default: language.default.app_materijali_select,
  },
  app_country_materijal: {
    data: {},
    data_default: {},
    data_trigger: "loc_country_value",
    images: {},
    images_default: {},
    images_trigger: "loc_country_value",
  },
  app_country_slike: {
    data: {},
    data_default: {},
    data_trigger: "loc_country_value",
    images: {},
    images_default: {},
    images_trigger: "loc_country_value",
  },
  app_sklopovi_default: {
    data: [],
    data_default: [],
    data_trigger: "loc_country_value",
  },
  app_tekuci_sklopovi: {
    data: [],
    data_trigger: "loc_country_value",
    data_default: [],
  },
  typ_stanje: {
    value: 1,
    data: [],
    data_trigger: "loc_country_value",
    data_default: [],
    title: "",
    title_default: "New house",
  },
  pos_nagib: {
    value: 1,
    data: [],
    data_trigger: "loc_country_value",
    data_default: [],
    select: {},
    select_default: { 1: "Less than 45 deg", 2: "More than 45 deg" },
    select_operation: "blend",
    title: "",
    title_default: "Hip > 45°",
  },
  pos_standard: {
    data: [],
    data_trigger: "loc_country_value",
    data_default: [],
    select: {},
    select_default: { 0: "Standard", 1: "Recomended", 2: "NZEB" },
    select_operation: "blend",
  },
  pos_u_max_options: {
    title: "",
    title_default: "U max options",
  },
  typ_floorarea: {
    value_default: 120,
    value: 120,
    title: "",
    title_default: "Total floor heated area",
  },
  app_height: {
    data_value_list: ["2.5", "2.6", "2.7", "2.8", "2.9", "3", "3.1", "3.2", "3.3", "3.4", "3.5"],
    data_select: ["2.5", "2.6", "2.7", "2.8", "2.9", "3", "3.1", "3.2", "3.3", "3.4", "3.5"].map(
      (x) => "" + app_math.numberWithCommas(+x, 1, 0)
    ),
    title: "",
    title_default: "Floor height",
    value: 2.8,
    value_default: 2.8,
  },
  atc_height: {
    data_value_list: ["2.5", "2.6", "2.7", "2.8", "2.9", "3", "3.1", "3.2", "3.3", "3.4", "3.5"],
    data_select: ["2.5", "2.6", "2.7", "2.8", "2.9", "3", "3.1", "3.2", "3.3", "3.4", "3.5"].map(
      (x) => "" + app_math.numberWithCommas(+x, 1, 0)
    ),
    title: "",
    title_default: "Attic height:",
    value: 2.8,
    value_default: 2.8,
  },
  typ_brojfasada: {
    data_select: ["1", "2"],
    title: "",
    title_default: "Number of windy facades",
    value: 2,
  },
  typ_constdate: {
    title: "",
    title_default: "Construction date",
    value: "",
    source: "computed",
    data_value: "middle",
    data: [],
    data_default: [],
    data_trigger: "loc_country_value",
    data_select: [],
    data_select_default: [],
    data_select_trigger: "loc_country_value",
  },
  typ_ceiling: {
    title: "",
    title_default: "Tip tavana",
    select: [],
    select_default: ["Prohodan tavan", "Neprohodan tavan"],
    select_operation: "blend",
    data: [1, 2],
    value: 1,
    value_default: 1,
  },
  loc_sun: {
    value_default: 2,
    select: [],
    select_default: ["Exposed", "Medium", "Shadowed"],
    select_operation: "blend",
    data: [1, 2, 3],
    value: 2,
  },
  loc_wind: {
    value_default: 2,
    select: [],
    select_default: ["Very", "Medium", "Sheltered"],
    select_operation: "blend",
    data: [1, 2, 3],
    value: 2,
  },
  app_back: { title: "", title_default: "Back" },
  app_ok: { title: "", title_default: "U redu" },
  pos_nointervention_info: {
    title: "",
    title_default:
      "Čak i ako ne želite da intervenišete na nekoj od pozicija, morate da potvrdite postojeće stanje svake pozicije kako bi odabir ušao u krajnju kalkulaciju",
  },
  app_back_to_house: { title: "", title_default: "Back to house selection" },
  list_what_isolation: { title: "", title_default: "Šta izolujemo i čime" },
  list_solution: { title: "", title_default: "Izolaciono rešenje" },
  list_no_intervention: { title: "", title_default: "Zadržano postojeće stanje pozicije" },
  list_no_intervention_detail: { title: "", title_default: "Zadržano postojeće stanje pozicije na kući!" },
  list_no_position: { title: "", title_default: "Pozicija nije definisana!" },
  list_no_position_detail: {
    title: "",
    title_default: "Klikom na plavi marker na modelu kuće odaberite tip pozicije na vašoj kući.",
  },
  app_next: { title: "", title_default: "Next" },
  app_delete: { title: "", title_default: "Delete" },
  app_confirm: { title: "", title_default: "Confirm" },
  app_proceed: { title: "", title_default: "Proceed" },
  app_cancel: { title: "", title_default: "Cancel" },
  app_settings: { title: "", title_default: "Settings" },
  app_change_settings: { title: "", title_default: "Change settings" },
  app_additional_options: { title: "", title_default: "Additional options" },
  app_choose_house: { title: "", title_default: "Choose your house" },
  app_summary: { title: "", title_default: "SUMMARY" },
  app_welcome: { title: "", title_default: "Welcome" },
  app_cta: { title: "", title_default: "CTA" },
  app_sprat: { title: "", title_default: "floor" },
  app_spratovi: { title: "", title_default: "floors" },
  app_intervention_reset: {
    title: "",
    title_default: "If you proceed, all interventions will be reset!",
  },
  app_intervention_20_21_reset: {
    title: "",
    title_default: "If you proceed, interventions Floor on the ground and Basement wall will be reset!",
  },
  app_intervention_all_reset: {
    title: "",
    title_default: "If you proceed, all manually set window area, roof window area and interventions will be reset!",
  },
  app_intervention_20_21_all_reset: {
    title: "",
    title_default:
      "If you proceed, all manually set window area, roof window area and interventions Floor on the ground and Basement wall will be reset!",
  },
  pos_window: {
    select: [],
    select_default: ["Plastic", "Wooden", "Metal"],
    select_operation: "blend",
    data: [0, 1, 2],
  },
  typ_window_delete: {
    title: "",
    title_default:
      "If you proceed, all manually set window area, and roof window area data will be reset to default value!",
  },
  typ_data_coerce: {
    title: "",
    title_default: "Value out of range. Automatically adjusted to regular value!",
  },
  pos_20_21: {
    title: "",
    title_default:
      "Ako prvo unesete intervenciju Zid u tlu, posle nećete moći da unesete intervenciju Pod na tlu bez brisanja ove intervencije.",
  },
  pos_21_20_start: {
    title: "",
    title_default: "Rad na intervenciji Pod na tlu će poništiti intervenciju Zid u tlu.",
  },
  pos_21_20_delete: {
    title: "",
    title_default: "Brisanje intervencije Pod na tlu će takođe obrisati intervenciju Zid u tlu.",
  },
  pos_intervention_reset: {
    title: "",
    title_default: "Potvrdite brisanje intervencije.",
  },
  app_created: {
    title: "",
    title_default: "Created and developed by:",
  },
  app_arhitektura: {
    title: "",
    title_default: "Arhitektura i Energija",
  },
  app_piktogram: {
    title: "",
    title_default: "Piktogram Studio",
  },
  app_reserved: {
    title: "",
    title_default: "All rights reserved to",
  },
  app_start: { title: "", title_default: "Terms & conditions" },
  app_finish: { title: "", title_default: "Call to action" },
  loc_select: { title: "", title_default: "LOCATION PARAMETERS" },
  loc_additional: { title: "", title_default: "ADDITIONAL DATA" },
  loc_calculation: { title: "", title_default: "CALCULATION" },
  typ_select: { title: "", title_default: "TYPE" },
  typ_geometry: { title: "", title_default: "Izaberite vašu kuću" },
  typ_heating: { title: "", title_default: "Kako se grejete?" },
  calc_savings_desktop: { title: "", title_default: "Godišnja ušteda novca i energije" },
  calc_heating_desktop: { title: "", title_default: "Grejanje" },
  app_less_parameters: { title: "", title_default: "Less options" },
  app_more_parameters: { title: "", title_default: "More options" },
  pos_heading: { title: "", title_default: "Pozicije na kući" },
  pos_existing: { title: "", title_default: "EXISTING STATE" },
  pos_new: { title: "", title_default: "Novo stanje" },
  pos_intervention: { title: "", title_default: "INTERVENTION" },
  pos_intervention_on: { title: "", title_default: "Uključite da dodate izolaciju" },
  list_change: { title: "", title_default: "Izmeni" },
  pos_current_insulation: { title: "", title_default: "Debljina trenutne izolacije" },
  list_define_position: { title: "", title_default: "Definišite poziciju" },
  list_add_insulation: { title: "", title_default: "Dodajte izolaciju" },
  pos_thickness: { title: "", title_default: "Wall thickness" },
  pos_insulation: { title: "", title_default: "Insulation thickness (cm)" },
  pos_expert: { title: "", title_default: "Expert mode" },
  pos_inside: { title: "", title_default: "Izolacija unutra" },
  pos_inside_description: { title: "", title_default: "Insulation is installed inside" },
  pos_outside: { title: "", title_default: "Izolacija spolja" },
  pos_outside_description: { title: "", title_default: "Insulation is installed outside" },
  pos_above: { title: "", title_default: "Izolacija iznad" },
  pos_below: { title: "", title_default: "Izolacija ispod" },
  pos_u_value_options: { title: "", title_default: "U value options" },
  pos_u_value_low: { title: "", title_default: "Not satisfied" },
  pos_u_value_good: { title: "", title_default: "Satisfied" },
  list_heading: { title: "", title_default: "LIST OF INTERVENTIONS" },
  list_existing: { title: "", title_default: "Existing State" },
  list_intervention: { title: "", title_default: "Intervention solution" },
  calc_calculation: { title: "", title_default: "CALCULATION" },
  calc_existing: { title: "", title_default: "Existing" },
  calc_intervention: { title: "", title_default: "Intervention" },
  calc_heat: { title: "", title_default: "HEAT" },
  calc_energy: { title: "", title_default: "Energy class" },
  calc_offer: { title: "", title_default: "REQUEST OFFER" },
  calc_again: { title: "", title_default: "Or calculate again" },
  calc_again_desktop: { title: "", title_default: "Izračunajte ponovo" },
  calc_consumption: { title: "", title_default: "Godišnja potrošnja" },
  calc_savings: { title: "", title_default: "Ušteda godišnje" },
  app_privacy: { title: "", title_default: "Privacy policy" },
  app_terms: { title: "", title_default: "Terms and conditions" },
  app_header: { title: "", title_default: "Kalkulator energetske efikasnosti" },
  typ_select_house: { title: "", title_default: "Unesite podatke o kući" },
  typ_house_selection: { title: "", title_default: "Izaberite drugu kuću" },
  typ_house_parameters: { title: "", title_default: "Parametri kuće" },
  pos_confirm: { title: "", title_default: "Potvrdite postojeće stanje" },
  pos_izaberi_stanje: { title: "", title_default: "Izaberite vaše postojeće stanje" },
  pos_idite_desno: {
    title: "",
    title_default: "Potvrdite postojeće stanje bez intervencije ili aktivirajte INTERVENCIJU, a zatim potvrdite sve.",
  },
  pos_deaktiviraj: { title: "", title_default: "Deaktiviraj intervenciju" },
  pos_aktiviraj: { title: "", title_default: "Kliknite za intervenciju" },
  pos_confirm_all: { title: "", title_default: "Potvrdite sve" },
  pos_description: {
    title: "",
    title_default: "Potvrdite postojeće stanje dole navedenih pozicija i unesite željenu intervenciju",
  },
  calc_disclaimer: {
    title: "",
    title_default:
      "All monetary values are based on average prices and there might be a variation depending on where you live and what type of agreement you have",
  },
  energy_disclaimer: {
    title: "",
    title_default: "*Dobijeni energetski razred zavisi od tačnosti unesenih parametara",
  },
  typ_floornumber: {
    data_select: ["1", "2", "3", "4"],
    value: 2,
    value_default: 2,
    title: "",
    title_default: "Number of floors",
  },
  typ_vrstatla: {
    title: "",
    title_default: "Vrsta tla:",
    select: [],
    select_default: ["Glina, nasip", "Pesak, šljunak", "Homogena stena"],
    select_operation: "blend",
    data: ["1.5", "2", "3.5"],
    value: 2,
    value_default: 2,
  },
  pos_status: {
    value: {},
    source: "computed",
    watch: ["typ_house", "typ_constdate"],
  },
  pos_position_from: {
    select: {},
    select_default: {
      1: "Odaberite postojeće stanje Vašeg fasadnog zida",
      5: "Odaberite postojeće stanje Vašeg ravnog krova",
      7: "Odaberite postojeće stanje Vašeg kosog krova",
      18: "Odaberite postojeće stanje Vašeg plafona ispod negerejanog tavana",
      19: "Odaberite postojeće stanje Vašeg poda iznad negrejanog podruma",
      20: "Odaberite postojeće stanje Vašeg zida u tlu",
      21: "Odaberite postojeće stanje Vašeg poda na tlu",
      // "30": "Zid u potkrovlju",
      10: "Odaberite postojeće stanje Vaših prozora",
      13: "Odaberite postojeće stanje Vaših vrata",
      60: "Odaberite postojeće stanje Vaših krovnih prozora",
    },
  },
  pos_position: {
    select: {},
    select_default: {
      1: "Fasadni zid",
      5: "Ravan krov",
      7: "Kos krov",
      18: "Plafon ispod negrejanog tavana",
      19: "Pod iznad negrejanog podruma",
      20: "Zid u tlu",
      21: "Pod na tlu",
      // "30": "Zid u potkrovlju",
      10: "Prozori",
      13: "Vrata",
      60: "Krovni prozori",
    },
    select_operation: "blend",
    data: {
      1: {
        Tip: 1,
        Redosled: 10,
        Mogucnost: ["hahb", "hanhb", "hat", "nhahb", "nhanhb", "nhat", "phb", "pnhb", "pt", "ao"],
      },
      5: {
        Tip: 1,
        Redosled: 70,
        Mogucnost: ["phb", "pnhb", "pt"],
      },
      7: {
        Tip: 1,
        Redosled: 60,
        Mogucnost: ["hahb", "hanhb", "hat", "ao"],
      },
      18: {
        Tip: 1,
        Redosled: 100,
        Mogucnost: ["nhahb", "nhanhb", "nhat"],
      },
      19: {
        Tip: 1,
        Redosled: 90,
        Mogucnost: ["hanhb", "nhanhb", "pnhb"],
      },
      20: {
        Tip: 1,
        Redosled: 110,
        Mogucnost: ["hahb", "nhahb", "phb"],
      },
      21: {
        Tip: 1,
        Redosled: 50,
        Mogucnost: ["hahb", "hat", "nhahb", "nhat", "phb", "pt"],
      },
      30: {
        Tip: 1,
        Redosled: 80,
        Mogucnost: ["hahb", "hanhb", "hat", "ao"],
      },
      10: {
        Tip: 2,
        Redosled: 20,
        Mogucnost: ["hahb", "hanhb", "hat", "nhahb", "nhanhb", "nhat", "phb", "pnhb", "pt", "ao"],
      },
      13: {
        Tip: 2,
        Redosled: 40,
        Mogucnost: ["hahb", "hanhb", "hat", "nhahb", "nhanhb", "nhat", "phb", "pnhb", "pt"],
      },
      60: {
        Tip: 2,
        Redosled: 30,
        Mogucnost: ["hahb", "hanhb", "hat"],
      },
    },
  },
  pos_house: {
    images: {},
    images_default: images.pos_house,
    images_trigger: "loc_country_value",
    images_operation: "blend",
  },
  typ_house: {
    data: {},
    data_default: {
      nhanhb: { basement: 0, attic: 0 },
      nhahb: { basement: 1, attic: 0 },
      hanhb: { basement: 0, attic: 1 },
      hahb: { basement: 1, attic: 1 },
      nhat: { basement: -1, attic: 0 },
      hat: { basement: -1, attic: 1 },
      pnhb: { basement: 0, attic: -1 },
      phb: { basement: 1, attic: -1 },
      pt: { basement: -1, attic: -1 },
      ao: { basement: -1, attic: 1 },
    },
    data_trigger: "loc_country_value",
    value: "",
    source: "computed",
    data_value: "first",
    title: {},
    title_operation: "blend",
    // ne diraj title default jer je engleski supalj
    title_default: {
      hahb: "sa grejanim podrumom i potkrovljem",
      hanhb: "sa negrejanim podrumom i potkrovljem",
      nhahb: "sa grejanim podrumom i tavanom",
      nhanhb: "sa negrejanim podrumom i tavanom",
      pnhb: "sa ravnim krovom i negrejanim podrumom",
      hat: "sa potkrovljem",
      nhat: "sa tavanom",
      pt: "sa ravnim krovom",
      ao: "samo potkrovlje",
      phb: "sa ravnim krovom i grejanim podrumom",
    },
    images: {},
    images_default: images.typ_house,
    images_trigger: "loc_country_value",
    images_operation: "blend",
    models: {
      hahb: "kucica01.babylon",
      hanhb: "kucica02.babylon",
      hat: "kucica03.babylon",
      nhahb: "kucica04.babylon",
      nhanhb: "kucica05.babylon",
      nhat: "kucica06.babylon",
      phb: "kucica07.babylon",
      pnhb: "kucica08.babylon",
      pt: "kucica09.babylon",
      ao: "kucica10.babylon",
    },
  },
  typ_override_window: {
    title: "",
    title_default: "Total windows area:",
    value: 0,
    value_default: 0,
    source: "computed",
    watch: ["typ_floorarea", "typ_floornumber", "app_height", "atc_height", "typ_house"],
  },
  typ_override_roof_window: {
    title: "",
    title_default: "Total roof windows area:",
    value: 0,
    value_default: 0,
    source: "computed",
    watch: ["typ_floorarea", "typ_floornumber", "atc_height", "typ_house"],
  },
  typ_override_window_manual: {
    value: false,
    value_default: false,
  },
  typ_override_roof_window_manual: {
    value: false,
    value_default: false,
  },
  typ_dubina: {
    data_value_list: ["0", "0.5", "1", "1.5", "2", "2.5", "3"],
    data_select: ["0", "0.5", "1", "1.5", "2", "2.5", "3"].map((x) => "" + app_math.numberWithCommas(+x, 1, 0)),
    value: 0,
    value_default: 0,
    title: "",
    title_default: "Dubina ukopavanja:",
    source: "computed",
    watch: ["typ_house"],
  },
  loc_country: {
    data: {},
    data_default: {},
    data_trigger: "app_residence_value",
    value: "",
    source: "computed",
    data_value: Settings.develop ? "first" : Settings.country,
    select: {},
    select_default: language.default.loc_country_select,
    select_operation: "blend",
  },
  app_language: {
    data: [],
    value: "eng",
  },
  app_residence: {
    value: "",
  },
  loc_city: {
    data: {},
    data_default: {},
    data_trigger: "loc_country_value",
    value: "",
    source: "computed",
    watch: ["loc_country"],
    select: {},
    select_default: language.default.loc_city_select,
    select_operation: "blend",
  },
  typ_grejanje_cena: {
    data: {},
    data_default: {
      1: 0.1,
      2: 0.1,
      3: 0.1,
      4: 0.1,
      5: 0.1,
      6: 0.1,
      7: 0.1,
      8: 0.1,
      9: 0.1,
      10: 0.1,
      11: 0.1,
      12: 0.1,
      13: 0.1,
      14: 0.1,
      15: 0.1,
      16: 0.1,
    },
    data_trigger: "loc_country_value",
  },
  calc_order: {
    value: "",
    data: "",
    data_default: "",
    data_trigger: "loc_country_value",
    data_value: "copy",
    source: "computed",
  },
  currency: {
    value: "",
    data: "",
    data_default: "",
    data_trigger: "loc_country_value",
    data_value: "copy",
    source: "computed",
  },
  currency_icon: {
    value: "",
    data: "",
    data_default: "",
    data_trigger: "loc_country_value",
    data_value: "copy",
    source: "computed",
  },
  ga_gtag: {
    value: "",
    data: "",
    data_default: "",
    data_trigger: "loc_country_value",
    data_value: "copy",
    source: "computed",
  },
  // Container ID currently not used dynamically
  // ga_container_id: {
  //   value: "",
  //   data: "",
  //   data_default: "",
  //   data_trigger: "loc_country_value",
  //   data_value: "copy",
  //   source: "computed",
  // },
  typ_grejanje_order: {
    data: [],
    data_default: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    data_trigger: "loc_country_value",
  },
  typ_grejanje_default: {
    value: -1,
    data: -1,
    data_default: -1,
    data_value: "copy",
    source: "computed",
    data_trigger: "loc_country_value",
  },
  typ_grejanje: {
    data: {},
    data_default: {
      1: { korisnost: 0.8, tip: "ulje" },
      2: { korisnost: 0.9, tip: "gas" },
      3: { korisnost: 0.8, tip: "ugalj" },
      4: { korisnost: 0.8, tip: "biomasa" },
      5: { korisnost: 1, tip: "struja" },
      6: { korisnost: 0.95, tip: "centralno" },
      7: { korisnost: 0.95, tip: "kogeneracija" },
      8: { korisnost: 0.8, tip: "ground" },
      9: { korisnost: 0.8, tip: "pelet" },
      10: { korisnost: 0.8, tip: "kerozin" },
      11: { korisnost: 0.9, tip: "briketi_od_uglja" },
      12: { korisnost: 0.9, tip: "antracit" },
      13: { korisnost: 0.9, tip: "lignit" },
      14: { korisnost: 0.9, tip: "split" },
      15: { korisnost: 0.9, tip: "mazut" },
      16: { korisnost: 0.9, tip: "propan" },
    },
    data_trigger: "loc_country_value",
    value: "",
    source: "computed",
    watch: ["loc_country"],
    title: {},
    title_operation: "blend",
    // ne diraj title default jer je engleski supalj
    title_default: {
      1: "Heating oil",
      2: "Gas",
      3: "Coal",
      4: "Wood",
      5: "Electricity",
      6: "Distant heating – fossil",
      7: "Distant heating – Cogeneration",
      8: "Ground heating",
      9: "Wood pellets",
      10: "Kerosene",
      11: "Briketi od uglja",
      12: "Antracit",
      13: "Lignit",
      14: "Split sistem",
      15: "Mazut",
      16: "Propan",
    },
    images: {},
    images_default: images.heating,
    images_trigger: "loc_country_value",
    images_operation: "blend",
  },
  typ_mobile_carousel_click: {
    title: "",
    title_default: "Tap on icon to select",
  },
  typ_desktop_carousel_click: {
    title: "",
    title_default: "Click on icon to select",
  },
  typ_grejanje_selected: {
    value: true,
  },
  loc_additional_data: {
    value: false,
  },
  typ_additional_data: {
    value: false,
  },
  typ_house_geometry: {
    title: "",
    title_default: "Unesite parametre za kuću",
  },
  typ_house_tip: {
    title: "",
    title_default: "Izaberite tip vaše kuće",
  },
  pos_define_positions: { title: "", title_default: "Izaberite pozicije na kući" },
  pos_define_interventions: { title: "", title_default: "Izaberite poziciju za intervenciju" },
  pos_postojece_proracun: { title: "", title_default: "Proračun postojećeg stanja" },
  pos_info_1: {
    title: "",
    title_default:
      "Kliknite na plavi kružić na modelu kuće kako biste definisali postojeće stanje pozicije na Vašoj kući.",
  },
  pos_info_2: {
    title: "",
    title_default: "Kada potvrdite postojeće stanje svih pozicija možete da pređete na sledeći korak.",
  },
  pos_info_click: {
    title: "",
    title_default: "Kliknite na sledeću poziciju na kući",
  },
  pos_info_title: {
    title: "",
    title_default: "Definisane su sve postojeće pozicije na vašoj kući.",
  },
  pos_info_subtitle_1: {
    title: "",
    title_default:
      "Ukoliko želite da izvršite izmene ili proverite da li ste izabrali pravilno postojeće tanje pozicije, kliknite na zeleni kružić na kući ili na naziv pozicije u tabeli sa leve strane.",
  },
  pos_info_subtitle_2: {
    title: "",
    title_default: 'Ako ste završili sa definisanjem pozicija kliknite na dugme "Dalje"',
  },
  calc_title_a: {
    title: "",
    title_default: "Sjajno!",
  },
  calc_subtitle_a: {
    title: "",
    title_default: "Vaša kuća je u dobrom stanju.",
  },
  calc_description_a: {
    title: "",
    title_default: 'Ukoliko želite dodatno da poboljšate stanje vaše kuće kliknite na dugme "Unapredi"',
  },
  calc_title_b: {
    title: "",
    title_default: "Nije loše.",
  },
  calc_subtitle_b: {
    title: "",
    title_default: "Moglo bi mnogo bolje!",
  },
  calc_description_b: {
    title: "",
    title_default: 'Hajde da dodatno unapredimo stanje Vaše kuće klikom na dugme "Unapredi"',
  },
  calc_title_c: {
    title: "",
    title_default: "Nije dobro!",
  },
  calc_subtitle_c: {
    title: "",
    title_default: "Vaša kuća troši previše!",
  },
  calc_description_c: {
    title: "",
    title_default: 'Hajde da unapredimo stanje Vaše kuće klikom na dugme "Unapredi"',
  },
  calc_confirm: {
    title: "",
    title_default: "Unapredi",
  },
  calc_year: {
    title: "",
    title_default: "GODIŠNJA potrošnja NOVCA I ENERGIJE",
  },
  calc_class: {
    title: "",
    title_default: "Energetska klasa",
  },
  calc_uporedno: {
    title: "",
    title_default: "Uporedno stanje godišnje potrošnje",
  },
  calc_advanced: {
    title: "",
    title_default: "Unapređeno stanje",
  },
  pos_intervention_start: {
    title: "",
    title_default: "Kliknite na poziciju na kući na kojoj želite da unapredite stanje.",
  },
  pos_intervention_back: {
    title: "",
    title_default: "Zadržite postojeće stanje.",
  },
  list_materijal_confirm: {
    title: "",
    title_default: "Potvrdi poziciju",
  },
  list_more: {
    title: "",
    title_default: "Želite da unapredite još neku poziciju na kući?",
  },
  list_more_yes: {
    title: "",
    title_default: "Da, želim",
  },
  list_more_no: {
    title: "",
    title_default: "Ne želim",
  },
  list_final_top: {
    title: "",
    title_default: 'Ako ste završili sa dodavanjem izolacije kliknite na dugme "Završi intervenciju"',
  },
  list_final_middle: {
    title: "",
    title_default: "Ukoliko želite da izolujete još neku poziciju kliknite na istu poziciju na kući.",
  },
  list_final: {
    title: "",
    title_default: "Završi intervenciju",
  },
  list_position: {
    title: "",
    title_default: "Lista pozicija",
  },
  list_additional: {
    title: "",
    title_default: "Ukoliko želite da izolujete još neku poziciju kliknite na istu poziciju na kući.",
  },
  calc_final: {
    title: "",
    title_default: "Finalni proračun",
  },
  app_politika_privatnosti: {
    title: "",
    title_default: "http://www.kamenavuna.com/politika-privatnosti-kalkulator/",
  },
  app_uslovi_koriscenja: {
    title: "",
    title_default: "http://www.kamenavuna.com/uslovi-koriscenja-kalkulator/",
  },
};
